import { FormattedMessage } from 'react-intl';
import { useModal } from '../../../utils/modal';
import Button from '../../atoms/Button';
import DebugPanelContent from './DebugPanelContent';
import './style.scss';

const DebugPanel = () => {
  const { toggleModal } = useModal();

  const debugModalConfig = {
    children: <DebugPanelContent onClose={toggleModal} />,
    onEscapeKey: () => toggleModal(),
    onClose: () => toggleModal(),
    onClickOutside: () => toggleModal(),
    contentClassName: 'debug__modal-content'
  };

  const showDebugModal = () => toggleModal(debugModalConfig);

  return (
    <Button
      type="button"
      secondary
      className="debug__open-panel"
      onClick={showDebugModal}
      data-test-id="debug-panel-open-button"
    >
      <FormattedMessage id="debug.debugPanel" />
    </Button>
  );
};

export default DebugPanel;
